import { Auth } from 'aws-amplify';
import InvalidCecotecEmailError from 'errors/InvalidCecotecEmailError';
import { hasPermissions } from 'modules/user-has-permission/user-has-permission';

export async function login(username, password) {
  return await Auth.signIn(username, password);
}

export async function forgotPassword(username) {
  return await Auth.forgotPassword(username);
}

export async function resetPassword(username, code, newPassword) {
  return await Auth.forgotPasswordSubmit(username, code, newPassword);
}

export async function register(email, password) {
  const emailParts = email.split('@');
  const username = emailParts[0];

  if (emailParts[1] !== 'cecotec.es') throw new InvalidCecotecEmailError();

  return await Auth.signUp({
    username,
    password,
    attributes: {
      email,
    },
  });
}

export async function isLoggedIn() {
  try {
    const { idToken } = await Auth.currentSession();
    const userHasPermissions = hasPermissions(idToken.payload.permissions);

    return !!idToken.jwtToken && userHasPermissions;
  } catch (error) {
    return false;
  }
}

export async function getSession() {
  try {
    return await Auth.currentSession();
  } catch (error) {
    return false;
  }
}

export async function logout() {
  return await Auth.signOut();
}
